import axios from "axios";
import { BASE_URL } from "config";
import { Endpoints } from "services/urls";

export function checkFilters(filters: any) {
  let filterParams = {};
  Object.keys(filters).forEach((key) => {
    filterParams = {
      ...filterParams,
      ...(filters[key] ? { [key]: filters[key] } : {}),
    };
  });
  // Build key=value&key=value with proper encoding. The previous
  // entries.join("&").replaceAll(",", "=") corrupted any value containing a comma.
  const finalFilters = Object.entries(filterParams)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join("&");
  return finalFilters;
}

export const apiHelper = (url: string, filters: any) => {
  const finalFilters = checkFilters(filters);
  return finalFilters !== "" ? `${url}?${finalFilters}` : url;
};

export const Axios = axios.create({
  baseURL: BASE_URL,
  headers: {
    ln: "fa",
  },
});

Axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.lt = token;
  }
  return config;
});

export function getMedia(hash: string) {
  return `${BASE_URL}${Endpoints.media.get}?hash=${hash}`;
}
